import AnTable from '../../components/AnTable/index'
import { getRolesData } from '@components/Categories/helper';
import { useCallback, useEffect, useState } from 'react';
import ROLES_COLUMNS_INFO from './RoleListColumns'



const RoleList = () => {

    type RolesDataTypes = {       
        id?: number,
        name?: string,
        type?: string,
        noOfUsers?: number
    }

    type RolesType = [
        RolesDataTypes
    ]

    const [rolesData, setRolesData] = useState<RolesType>([{}])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const getRoles = useCallback( async () => {
        try{
            const rolesResponse = await getRolesData('/role')
            if(rolesResponse && rolesResponse['result'] && rolesResponse['result']['success']){
                setRolesData(rolesResponse['roles'])
                setIsLoading(false)
            }
        }
        catch(error){
            return error
        }
 
    },[setRolesData])

    useEffect(()=>{
        setIsLoading(true)
        getRoles()
    },[getRoles])

    return (  
        <AnTable
            data = {rolesData}
            isLoading = {isLoading}
            configuration = {ROLES_COLUMNS_INFO}
            onCLickRow = {()=>{}} 
        />
    )
}

export default RoleList
